var React = require('react');

function SqftIconComp (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"_x31_","stroke":"currentColor","transform":"matrix(1.0156 0 0 1.1358 0 -7.693)"},React.createElement("path",{"d":"m128 121.23h-53.126v-14.459l-22.159 0.011-4e-3 -6.095 28.258-0.015v14.463h40.936v-48.084h-40.936v21.032h-6.095v-27.128h47.031v-48.084h-54.857v25.171h-6.095v-25.171h-12.372v-6.095h79.419zm-128-14.388v-100.07h23.365v6.095h-17.27v48.084h27.429v6.095h-27.429v33.69l21.406-0.021 6e-3 6.095zm67.048-39.791h-18.474v-6.095h12.378v-7.487h6.095v13.582z","fill":"#262626"})));
}

SqftIconComp.defaultProps = {"version":"1.1","viewBox":"0 0 130 130"};

module.exports = SqftIconComp;

SqftIconComp.default = SqftIconComp;
